// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__tQr4J","col":"styles_col__FkEev","fulfillmentStatus":"styles_fulfillmentStatus__10-Q_","emailCol":"styles_emailCol__3rahX"};